import config from '../webpack/config';

const basePath = config.basePath.replace(/\/+$/, '');

export default url => `${basePath}/${url.replace(/^\/+/, '')}`;



// WEBPACK FOOTER //
// ./js/utils/addBasePath.js